/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import dayjs, {Dayjs} from "dayjs";
import {Button, DatePicker, Input, InputNumber, Table, TableColumnsType} from "antd";
import {DeleteOutlined, EditOutlined} from "@ant-design/icons";
import styles from './PointAdjustHistoryTable.module.scss';
import {PointAdjustHistory, PointAdjustRankingData} from "../../PointAdjust.interface";

interface PointAdjustHistoryTableProps {
	record: PointAdjustRankingData;
	filteredRankingData: PointAdjustRankingData[];
	setFilteredRankingData: React.Dispatch<React.SetStateAction<PointAdjustRankingData[]>>;
	deleteHistory: (id: string) => any;
	editHistory: (history: PointAdjustHistory) => any;
}

const PointAdjustHistoryTable = ({ record, filteredRankingData, setFilteredRankingData, deleteHistory, editHistory }: PointAdjustHistoryTableProps) => {
	const preventInputDecimal = (e: any) => {
		if (e.key === '.' || e.key === 'Decimal') {
			e.preventDefault();
		}
	};

	const pointAdjustHistoryColumns: TableColumnsType<PointAdjustHistory> = [
		{
			title: '적용 날짜',
			dataIndex: 'pointAdjustDay',
			key: 'pointAdjustDay',
			width: 70,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => {
				return (
					<DatePicker
						value={record.pointAdjustDay ? dayjs(record.pointAdjustDay.toString(), 'YYYYMMDD'): null}
						format="YYYYMMDD"
						allowClear={false}
						onChange={(date: Dayjs, dateString: string | string[]) => {
							const newFilteredRankingData = filteredRankingData.map((item, idx) => {
								const isTarget = item.pointAdjustHistory.find(item => item.id === record.id);
								if (!isTarget) return item;
								return { ...item, pointAdjustHistory: item.pointAdjustHistory.map((el) => {
										if (el.id === record.id) return { ...el, pointAdjustDay: Number(dateString) };
										return el;
									})}
							});
							setFilteredRankingData(newFilteredRankingData);
						}}
					/>
				)
			},
		},
		{
			title: '업데이트 멤버',
			dataIndex: 'name',
			key: 'name',
			width: 60,
			align: 'center',
			className: styles.blackBackground,
		},
		{
			title: (
				<>
					<div>추가</div>
					<div>점수</div>
				</>
			),
			dataIndex: 'point',
			key: 'point',
			width: 40,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<InputNumber
					style={{ textAlign: 'center', width: '100%' }}
					value={record.point}
					onKeyDown={preventInputDecimal}
					onChange={(e) => {
						const newFilteredRankingData = filteredRankingData.map((item, idx) => {
							const isTarget = item.pointAdjustHistory.find(item => item.id === record.id);
							if (!isTarget) return item;
							return { ...item, pointAdjustHistory: item.pointAdjustHistory.map((el) => {
									if (el.id === record.id) return { ...el, point: e || 0 };
									return el;
								})}
						});
						setFilteredRankingData(newFilteredRankingData);
					}}
				/>
			),
		},
		{
			title: (
				<>
					<div>추가</div>
					<div>발주</div>
				</>
			),
			dataIndex: 'baljuCount',
			key: 'baljuCount',
			width: 40,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<InputNumber
					style={{ textAlign: 'center', width: '100%' }}
					value={record.baljuCount}
					onKeyDown={preventInputDecimal}
					onChange={(e) => {
						const newFilteredRankingData = filteredRankingData.map((item, idx) => {
							const isTarget = item.pointAdjustHistory.find(item => item.id === record.id);
							if (!isTarget) return item;
							return { ...item, pointAdjustHistory: item.pointAdjustHistory.map((el) => {
									if (el.id === record.id) return { ...el, baljuCount: e || 0 };
									return el;
								})}
						});
						setFilteredRankingData(newFilteredRankingData);
					}}
				/>
			),
		},
		{
			title: (
				<>
					<div>추가</div>
					<div>수주</div>
				</>
			),
			dataIndex: 'sujuCount',
			key: 'sujuCount',
			width: 40,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<InputNumber
					style={{ textAlign: 'center', width: '100%' }}
					value={record.sujuCount}
					onKeyDown={preventInputDecimal}
					onChange={(e) => {
						const newFilteredRankingData = filteredRankingData.map((item, idx) => {
							const isTarget = item.pointAdjustHistory.find(item => item.id === record.id);
							if (!isTarget) return item;
							return { ...item, pointAdjustHistory: item.pointAdjustHistory.map((el) => {
									if (el.id === record.id) return { ...el, sujuCount: e || 0 };
									return el;
								})}
						});
						setFilteredRankingData(newFilteredRankingData);
					}}
				/>
			),
		},
		{
			title: '조정 사유',
			dataIndex: 'reason',
			key: 'reason',
			width: 250,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<Input
					style={{ textAlign: 'left' }}
					value={record.reason}
					onChange={(e) => {
						const newFilteredRankingData = filteredRankingData.map((item, idx) => {
							const isTarget = item.pointAdjustHistory.find(item => item.id === record.id);
							if (!isTarget) return item;
							return { ...item, pointAdjustHistory: item.pointAdjustHistory.map((el) => {
									if (el.id === record.id) return { ...el, reason: e.target.value };
									return el;
								})}
						});
						setFilteredRankingData(newFilteredRankingData);
					}}
				/>
			),
		},
		{
			title: '수정',
			dataIndex: '',
			key: '',
			width: 30,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<Button
					shape='circle'
					type='primary'
					onClick={async () => editHistory(record)}
				>
					<EditOutlined />
				</Button>
			),
		},
		{
			title: '삭제',
			dataIndex: '',
			key: '',
			width: 30,
			align: 'center',
			className: styles.blackBackground,
			render: (value: any, record: PointAdjustHistory, index: number) => (
				<Button
					danger
					shape='circle'
					type='primary'
					onClick={async () => deleteHistory(record.id)}
				>
					<DeleteOutlined />
				</Button>
			),
		},
	];

	return (
		<Table
			bordered
			size="small"
			style={{ tableLayout: 'fixed' }}
			pagination={false}
			columns={pointAdjustHistoryColumns}
			dataSource={record.pointAdjustHistory.map((row) => {
				return ({ ...row, key: row.id })
			})}
		/>
	)
};

export default PointAdjustHistoryTable;
